<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{checkModuleIndex('TWLBMEM', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['TWLBMEM']}}</h2>
                    </div>
                    <div class="searchForm">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :disable-branch-nodes="false"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="right"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency" />
                            </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrencyFilter" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["WL"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_cwl"
                                            :placeholder="this.utilGetDDLanguage('MEM.WL')"
                                            v-model="chooseWinLoss">
                                </treeselect>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MT"]["MT"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_userType"
                                            :placeholder="this.utilGetDDLanguage('MT.MT')"
                                            v-model="searchIsTester" />
                            </div>
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                                <treeselect :key="dd_referralMemberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadReferralMemberOptions"
                                            :options="ddReferralMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                            @input="selectReferralMemberOptions"
                                            @deselect="deSelectReferralMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchReferralUserId" />
                            </div>-->
                        </div>
                        <div class='searchBtnCol'>
                            <CButton ref="search" v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
       
            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['TWLBMEML']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>

                </header>

                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <span v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </span>
                                    <!--1-->
                                    <span v-if="header == 'AGT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AG')" :class="setSortLogo('AG')"></i>
                                    </span>
                                    <!--1-->
                                    <span v-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')"></i>
                                    </span> <!--add sub time-->
                                    <!--1-->
                                    <span v-if="header == 'CKMMW'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CKMMW']}}
                                        <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')"></i>
                                    </span>
                                    <!--1-->
                                    <span v-if="header == 'NND'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['NND']}}
                                        <i @click="setSortTable('TAND')" :class="setSortLogo('TAND')"></i>
                                    </span>
                                    <span v-if="header == 'TND'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['TND']}}
                                        <i @click="setSortTable('TAD')" :class="setSortLogo('TAD')"></i>
                                    </span>
                                    <!--1-->
                                    <span v-if="header == 'AD'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['AD']}}
                                        <i @click="setSortTable('AD')" :class="setSortLogo('AD')"></i>
                                    </span>


                                    <!--1-->
                                    <span v-if="header == 'TANW'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['TANW']}}
                                        <i @click="setSortTable('TANW')" :class="setSortLogo('TANW')"></i>
                                    </span>

                                    <!--1-->
                                    <span v-if="header == 'TAW'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['TAW']}}
                                        <i @click="setSortTable('TAW')" :class="setSortLogo('TAW')"></i>
                                    </span>

                                    <!--1-->
                                    <span v-if="header == 'NP'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['NP']}}
                                        <i @click="setSortTable('NP')" :class="setSortLogo('NP')"></i>
                                    </span>
                                    <span v-if="header == 'TP'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['TP']}}
                                        <i @click="setSortTable('TP')" :class="setSortLogo('TP')"></i>
                                    </span>
                                    <span v-if="header == 'DLS'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['DLS']}}
                                        <i @click="setSortTable('DLS')" :class="setSortLogo('DLS')"></i>
                                    </span>
                                    <span v-if="header == 'AR'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['AR']}}
                                        <i @click="setSortTable('ARA')" :class="setSortLogo('ARA')"></i>
                                    </span>
                                    <span v-if="header == 'A'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['A']}}
                                        <i @click="setSortTable('AA')" :class="setSortLogo('AA')"></i>
                                    </span>
                                    <span v-if="header == 'TC'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['TC']}}
                                        <i @click="setSortTable('TCD')" :class="setSortLogo('TCD')"></i>
                                    </span>
                                    <span v-if="header == 'NB'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['NB']}}
                                        <i @click="setSortTable('NB')" :class="setSortLogo('NB')"></i>
                                    </span>
                                    <!--<span v-show="repoerIsCrypto" v-if="header == 'BCBA'">
                                        <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CYT']['BCBA']}}
                                        <i v-show="repoerIsCrypto" @click="setSortTable('TB')" :class="setSortLogo('BCBA')"></i>
                                    </span>
                                    <span v-show="repoerIsCrypto" v-if="header == 'BCWLA'">
                                        <i v-show="repoerIsCrypto" class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CYT']['BCWLA']}}
                                        <i v-show="repoerIsCrypto" @click="setSortTable('WLA')" :class="setSortLogo('BCWLA')"></i>
                                    </span>-->
                                    <span v-if="header == 'TB'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['TB']}}
                                        <i @click="setSortTable('TB')" :class="setSortLogo('TB')"></i>
                                    </span>
                                    <span v-if="header == 'WLA'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['WLA']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')"></i>
                                    </span>
                                    <span v-if="header == 'NPL'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['NPL']}}
                                        <i @click="setSortTable('NPL')" :class="setSortLogo('NPL')"></i>
                                    </span>
                                    <span v-if="header == 'HPL'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['APL']}}(%)
                                        <i @click="setSortTable('HPL')" :class="setSortLogo('HPL')"></i>
                                    </span>
                                    <span v-if="header == 'PWL'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['PWL']}}
                                        <i @click="setSortTable('PWL')" :class="setSortLogo('PWL')"></i>
                                    </span>
                                    <span v-if="header == 'HWL'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['WLBMRPT']['AWL']}}
                                        <i @click="setSortTable('AWL')" :class="setSortLogo('AWL')"></i>
                                    </span>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_reportList == null || arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_reportList" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header">
                                <span v-if="header == 'NO'">{{ CountItem(index+1) }}</span>
                                <span v-if="header == 'AGT'">
                                    <span class="grid-line">{{ data.AG }}</span>
                                    <Span class="saggroupname" v-if="data.SAGGN != ''">{{ data.SAGGN }}</Span>
                                    <span class="grid-line text-primary">{{ data.RU }}</span>
                                </span>
                                <span v-if="header == 'U'" class='kema-eft' @click="CheckingMember(data.AGI,data.I)">
                                    <span class="grid-line">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </span>
                                <span v-if="header == 'CKMMW'" :style="changeNegativecolor(data.CBL)" class="tableCtnRight d-block">{{formatNumber(data.CBL, 2, data.CS)}}</span>
                                <span v-if="header == 'NND'" class="tableCtnRight d-block">{{ data.TAND }}</span>
                                <span v-if="header == 'TND'" :style="changeNegativecolor(data.TAD)" class="tableCtnRight d-block">{{formatNumber(data.TAD, 2, data.CS)}}</span>
                                <span v-if="header == 'AD'" :style="changeNegativecolor(data.AD)" class="tableCtnRight d-block">{{formatNumber(data.AD, 2, data.CS)}}</span>
                                <span v-if="header == 'TANW'" class="tableCtnRight d-block">{{ data.TANW }}</span>
                                <span v-if="header == 'TAW'" style="color:red" class="tableCtnRight d-block">{{formatNumber(data.TAW, 2, data.CS)}}</span>
                                <span v-if="header == 'NP'" class="tableCtnRight d-block">{{ data.NP }}</span>
                                <span v-if="header == 'TP'" style="color:red" class="tableCtnRight d-block">{{formatNumber(data.TP, 2, data.CS)}}</span>
                                <span v-if="header == 'DLS'" style="color:red" class="tableCtnRight d-block">{{formatNumber(data.DLS, 2, data.CS)}}</span>
                                <span v-if="header == 'AR'" style="color:red" class="tableCtnRight d-block">{{formatNumber(data.ARA, 2, data.CS)}}</span>
                                <span v-if="header == 'A'" style="color:red" class="tableCtnRight d-block">{{formatNumber(data.AA, 2, data.CS)}}</span>
                                <span v-if="header == 'TC'" style="color:red" class="tableCtnRight d-block">{{formatNumber(data.TCD, 2, data.CS)}}</span>
                                <span v-if="header == 'NB'" class="tableCtnRight d-block">{{formatNumber(data.NB, 2, "")}}</span>
                                <span v-show="repoerIsCrypto" v-if="header == 'BCBA'" :style="changeNegativecolor(data.BCBA)" class="tableCtnRight d-block">{{data.BCBA}}</span>
                                <span v-show="repoerIsCrypto" v-if="header == 'BCWLA'" :style="changeNegativecolor(data.BCWLA)" class="tableCtnRight d-block">{{data.BCWLA}}</span>
                                <span v-if="header == 'TB'" :style="changeNegativecolor(data.TB)" class="tableCtnRight d-block">{{formatNumber(data.TB, 2, data.CS)}}</span>
                                <span v-if="header == 'WLA'" :style="changeNegativecolor(data.WLA)" class="tableCtnRight d-block">{{formatNumber(data.WLA, 2, data.CS)}}</span>
                                <span v-if="header == 'NPL'" :style="changeNegativecolor(data.NPL)" class="tableCtnRight d-block">{{formatNumber(data.NPL, 2, data.CS)}}</span>
                                <span v-if="header == 'HPL'" :style="changeNegativecolor(data.HPL)" class="tableCtnRight d-block">{{formatNumber(data.HPL, 2)}} %</span>
                                <span v-if="header == 'PWL'" :style="changeNegativecolor(data.PWL)" class="tableCtnRight d-block">{{formatNumber(data.PWL, 2, data.CS)}}</span>
                                <span v-if="header == 'HWL'" :style="changeNegativecolor(data.AWL)" class="tableCtnRight d-block">{{formatNumber(data.AWL, 2, data.CS)}}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "WLA", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                // dropdown value
                ddAgentList: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                dd_cwl: [
                    { id: '0', label: 'All' },
                    { id: '1', label: 'Win' },
                    { id: '2', label: 'Loss' },
                ],//win/Loss
                ddReferralMemberList: null,
                ddReferralDefaultMemberList: null,
                ddCurrencyList: null,
                dd_userType: [],
                // search fields
                searchAgi: 0,
                searchAgent: null,
                searchUserId: null,
                searchUserType: null,
                searchIsTester: null,
                chooseWinLoss: 0,
                searchUsername: null,
                searchReferralUserId: null,
                searchReferralUsername: null,
                searchGameProviderId: null,
                searchCurrency: null,
                searchCurrencyFilter: null,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                arr_reportList: [],
                arr_reportTotalList: [],
                reportType: null,
                skipPageUpdate: false,
                dd_memberKey: 0,
                dd_referralMemberKey: 0,
                sc_userid: 0,
                sc_username: null,
                sc_daterange: { startDate: null, endDate: null },
                sc_cur: null,
                sc_curf: null,
                sc_agi: null,
                sc_agent: null,
                constAccessType: constAccessType,
                needResetHeaders: false,
                defaultReportHeaders: ['NO', 'AGT', 'U', 'CKMMW', 'NND', 'TND', 'AD', 'TANW', 'TAW', 'NP', 'TP', 'DLS', 'AR', 'A', 'TC', 'NB', 'BCBA', 'BCWLA', 'TB', 'WLA', 'NPL', 'HPL', 'PWL', 'HWL'],
                reportHeaders: [],
                repoerIsCrypto: false,
                hideBrand: false,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            getMemberTypeList() {
                this.dd_userType = [{ id: '1', label: this.getLanguage['MEM']['NMEM'] }, { id: '2', label: this.getLanguage['MEM']['TMEM'] }];
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.searchAgi = 0;
                if (value) {
                    var agentList = value.split("-");
                    this.searchAgi = agentList[agentList.length - 1];
                }
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;

                if (this.searchAgi > 0) {
                    agentGId = this.searchAgi;
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }
                if (this.chooseWinLoss >= 0) {
                    path += "&f.CWL=" + this.chooseWinLoss;
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }

                if (this.searchGameProviderId) {
                    path += "&f.GPI=" + this.searchGameProviderId;
                }

                if (this.searchIsTester) {
                    path += "&f.ITU=" + this.searchIsTester;
                }

                if (this.searchCurrencyFilter) {
                    path += "&f.CI=" + this.searchCurrencyFilter;
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }
                }



                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.getDataApi(`/api/reports/winloss/totalbmem?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.repoerIsCrypto = false;
                            that.temp_providerName = null;
                            that.sc_userid = that.searchUserId;
                            that.sc_username = that.searchUsername;
                            that.sc_daterange = that.searchCreatedTS;
                            that.sc_cur = that.searchCurrency;
                            that.sc_curf = that.searchCurrencyFilter;
                            that.sc_agi = that.searchAgi;
                            that.sc_agent = that.searchAgent;

                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_reportList = d.D.Items;

                            for (var i = 0; i < d.D.Items.length; i++) {
                                if (d.D.Items[i].ICT)
                                    that.repoerIsCrypto = d.D.Items[i].ICT;
                            }
                        }
                    });

            },
            saveToExcel() {

                this.bool_fullLoading = false;
                var that = this;
                var agentGId = null;

                if (this.searchAgi > 0) {
                    agentGId = this.searchAgi;
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }
                if (this.chooseWinLoss >= 0) {
                    path += "&f.CWL=" + this.chooseWinLoss;
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }

                if (this.searchGameProviderId) {
                    path += "&f.GPI=" + this.searchGameProviderId;
                }

                if (this.searchCurrencyFilter) {
                    path += "&f.CI=" + this.searchCurrencyFilter;
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }
                }

                if (this.searchIsTester) {
                    path += "&f.ITU=" + this.searchIsTester;
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }


                window.open('/api/reports/winlossexcel/totalbmem?' + path, '_blank');
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectMemberOptions(node, instanceId) {
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == node) {
                            this.searchUsername = this.ddMemberList[i].label;
                            break;
                        }
                    }
                }
                else {
                    this.searchUsername = null;
                }
            },
            deSelectMemberOptions(node, instanceId) {
                this.searchUserId = null;
                this.searchUsername = null;
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            loadCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                        callback();
                    });
            },
            changeNegativecolor(value) {
                if (value < 0) {
                    return {
                        color: 'red',
                        display: 'block'
                    }
                }
                else if (value > 0) {
                    return {
                        color: 'green',
                        display: 'block'
                    }
                }
                return { display: 'block' }
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            resetColumn(headerName) {
                var that = this;
                if (!that.repoerIsCrypto) {
                    var myIndex = that.defaultReportHeaders.indexOf('BCBA');
                    if (myIndex !== -1) {
                        this.defaultReportHeaders.splice(myIndex, 1);
                    }
                    var myIndex = that.defaultReportHeaders.indexOf('BCWLA');
                    if (myIndex !== -1) {
                        this.defaultReportHeaders.splice(myIndex, 1);
                    }
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        watch: {
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/TotalWinLossByMember`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1) {
                                            if (!that.repoerIsCrypto && (that.defaultReportHeaders[i] == 'BCBA' || that.defaultReportHeaders[i] == 'BCWLA')) {
                                                continue;
                                            } else {
                                                that.reportHeaders.push(that.defaultReportHeaders[i]);
                                            }
                                        }
                                    }
                                }
                                //else
                                //    try {
                                //        that.reportHeaders = JSON.parse(d);
                                //    } catch (e) {
                                //        d += "]";
                                //        that.reportHeaders = JSON.parse(d);
                                //    }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                        if (!that.repoerIsCrypto) {
                                            var myIndex = that.defaultReportHeaders.indexOf('BCBA');
                                            if (myIndex !== -1) {
                                                that.defaultReportHeaders.splice(myIndex, 1);
                                            }
                                            var myIndex = that.reportHeaders.indexOf('BCBA');
                                            if (myIndex !== -1) {
                                                that.reportHeaders.splice(myIndex, 1);
                                            }

                                            var myIndex = that.defaultReportHeaders.indexOf('BCWLA');
                                            if (myIndex !== -1) {
                                                that.defaultReportHeaders.splice(myIndex, 1);
                                            }
                                            var myIndex = that.reportHeaders.indexOf('BCWLA');
                                            if (myIndex !== -1) {
                                                that.reportHeaders.splice(myIndex, 1);
                                            }
                                        }
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/TotalWinLossByMember/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            },
            getLanguage() {
                this.getReportList();
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS3';
            this.$parent.showActiveMenu = 'R.TWLBMEM';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.searchUserId = this.$route.query.i;
            this.searchUsername = this.$route.query.u;
            this.searchUserType = this.$route.query.ut;

            if (this.$route.query.gpi) {
                this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);
            }
            if ((this.searchUserType) && (this.searchUserType > 0)) {
                this.searchIsTester = this.searchUserType;
            }
            if (this.$route.query.sagi && this.$route.query.sagi != 0) {
                this.searchAgent = this.$route.query.sagi;

                if (this.$route.query.agi && this.$route.query.agi != 0) {
                    this.searchAgi = this.$route.query.agi;
                }
            }
            if (this.$route.query.cur) {
                this.searchCurrency = this.$route.query.cur;
            }
            if (this.$route.query.curf) {
                this.searchCurrencyFilter = this.$route.query.curf;
            }
            if (this.$route.query.df) {
                this.searchCreatedTS.startDate = this.$route.query.df;
            }
            if (this.$route.query.dt) {
                this.searchCreatedTS.endDate = this.$route.query.dt;
            }
            if (this.searchUserId && this.searchUsername) {
                this.ddDefaultMemberList = [
                    { id: this.searchUserId, label: this.searchUsername }
                ];
            }
            if (this.$route.query.as == 't') {
                this.bool_showDetails = true;
            }

            this.getMemberTypeList();
            this.getReportList();
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/TotalWinLossByMember.vue